"use strict";
exports.__esModule = true;
exports.cancelAccountFailureResponse = exports.cancelAccountSuccessResponse = exports.pausedAutopayResponse = exports.getLocationSuggestResponse = exports.oonSelfPayVirtualCardResponse = exports.getFeatureStatusFlexLiteResponse = exports.getFeatureStatusResponse = exports.oonSelfPayStartResponse = exports.getBillerResidentPrefillResponse = exports.getBillerPropertyUnitResponse = exports.getBillerPropertyDetailsFlexAnywhereResponse = exports.getBillerPropertyDetailsResponse = exports.getResumeOnboardingIVResponse = exports.getResumeOnboardingFAStatusResponse = exports.getResumeOnboardingEpisodicStatusResponse = exports.getCreditBuilderResumeOnboardingStatusResponse = exports.getResumeOnboardingStatusResponse = exports.getOnboardingStatusResponse = exports.inAppDownpaymentFailed = exports.propertiesSearchResponse = exports.paymentFailureExceptionResponse = exports.evaluateOutstandingBalanceNotDQResponse = exports.evaluateOutstandingBalanceDQResponse = exports.orchestrationEvaluateOfferResponseMLA = exports.getPricingOfferResponseMLA = exports.getPricingOfferFSLCResponse = exports.getPricingOfferSLCResponse = exports.getPricingOfferResponse = exports.orchestrationEvaluateOfferDuplicateSSNResponse = exports.orchestrationEvaluateDocumentVerificationOfferResponse = exports.orchestrationEvaluateIncomeVerificationOfferResponse = exports.orchestrationEvaluateCreditBuilderOfferResponse = exports.orchestrationEvaluateSLCOfferResponse = exports.orchestrationEvaluateOfferResponse = exports.orchestrationInitiateOfferResponse = exports.unpauseBillerAccountResponseFailed = exports.useVirtualCardResponse = exports.useGetDdaDecisionsIneligibleResponse = exports.useGetDdaDecisionsResponse = exports.useDdaResponse = exports.getRentAmountUpdateSurveyResponse = exports.overwriteCreateResponseZeroBalance = exports.overwriteCreateBTLResponseSLC = exports.overwriteCreateResponseBTL = exports.overwriteCreateBTHResponseSLC = exports.overwriteCreateResponsePastDue = exports.overwriteCreateResponse = exports.overwriteCreateMultipleRepaymentsResponse = exports.addCardResponse = exports.setupCardResponse = void 0;
exports.oonSelfPayStartSLCDisabledMonthTwoDepositPaid = exports.oonSelfPayStartSlcSPDisabledMonthTwoAdditionalDeposit = exports.oonSelfPayStartSlcSPDisabledMonthTwo = exports.oonSelfPayStartSlcSPDisabled = exports.oonSelfPayStartSlcSPEnabled = exports.flexAnywhereUpdateCard = exports.flexAnywhereDefaultPaymentFailure = exports.flexAnywhereGenericPaymentFailure = exports.flexAnywhereInsufficientFunds = exports.getRentReportingOptInStatus = exports.withdrawFundsMaxWithdrawalsReached = exports.withdrawFundsRateLimit = exports.addFundsMaxDepositsRateLimit = exports.withdrawFundsInvalidAmountFailure = exports.withdrawFundsFailure24Hours = exports.addFundsInvalidAmountFailure = exports.addFundsMaxDepositsFailure = exports.getCardsV2Credit = exports.getCardsV2Existing = exports.getCardsV2New = exports.creditCard = exports.newCard = exports.defaultCard = exports.setupCardV2ResponseGenericFailure = exports.setupCardV2ResponseCardLinkageFailure = exports.setupCardV2ResponseNew = exports.setupCardV2ResponseExisting = exports.walletBalanceResponseAddFunds = exports.walletBalanceResponse = exports.getBillerPropertyPortalDetailsResponse = exports.getBillerPropertyUnitsResponse = void 0;
var domain_1 = require("@genoa/domain");
var orchestration_1 = require("../orchestration");
var risk_1 = require("./risk");
var luxon_1 = require("luxon");
// Wallet
exports.setupCardResponse = {
    stripe_client_secret: '1E2D34D6F333FG34'
};
exports.addCardResponse = {
    stripe_payment_method_id: '123123123-123123-123123',
    stripe_customer_id: 'asdfasdf-asdf-asdfasdf-asdf'
};
// Balance Too High/ Balance Too Low
exports.overwriteCreateMultipleRepaymentsResponse = {
    overwrite_public_id: '100000-100000-100000-10000',
    payments: [
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            amount: 75000,
            bill_date: '2022-10-01',
            payment_category: domain_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '00010001'
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            amount: 37500,
            bill_date: '2022-10-16',
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010002'
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            amount: 37500,
            bill_date: '2022-10-18',
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '00010003'
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            bill_date: '2022-10-15',
            payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '00010004'
        },
    ],
    cla: { version: '2022-06-28' },
    tila: { version: '2022-06-28' },
    processing_fee: {
        debit_card_processing_fee_bps: 75
    }
};
// Balance Too High/ Balance Too Low
exports.overwriteCreateResponse = {
    overwrite_public_id: '100000-100000-100000-10000',
    payments: [
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 125000,
            bill_date: '2022-10-01'
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 1499,
            bill_date: '2022-10-15'
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 125000,
            bill_date: '2022-10-15'
        },
    ],
    cla: { version: '2022-06-28' },
    tila: { version: '2022-06-28' },
    processing_fee: {
        debit_card_processing_fee_bps: 75
    }
};
exports.overwriteCreateResponsePastDue = {
    overwrite_public_id: null,
    payments: [
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 1499,
            bill_date: '2022-10-15'
        },
    ],
    cla: { version: '2022-06-28' },
    tila: { version: '2022-06-28' },
    processing_fee: {
        debit_card_processing_fee_bps: 75
    }
};
exports.overwriteCreateBTHResponseSLC = {
    overwrite_public_id: '100000-100000-100000-10000',
    payments: [
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 127500,
            bill_date: '2022-10-01',
            is_security_deposit: true,
            processing_fee: 2500,
            processing_fee_percent: 2,
            base_amount: 125000
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 127500,
            bill_date: '2022-10-15',
            processing_fee: 2500,
            processing_fee_percent: 2,
            base_amount: 125000
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 127500,
            bill_date: '2022-10-27',
            processing_fee: 2500,
            processing_fee_percent: 2,
            base_amount: 125000
        },
    ],
    cla: { version: '2022-06-28' },
    tila: { version: '2022-06-28' },
    processing_fee: {
        debit_card_processing_fee_bps: 75
    }
};
exports.overwriteCreateResponseBTL = {
    overwrite_public_id: '100000-100000-100000-10000',
    payments: [
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 15000,
            bill_date: '2022-10-01'
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 1499,
            bill_date: '2022-10-15'
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 15000,
            bill_date: '2022-10-15'
        },
    ],
    cla: { version: '2022-06-28' },
    tila: { version: '2022-06-28' },
    processing_fee: {
        debit_card_processing_fee_bps: 75
    }
};
exports.overwriteCreateBTLResponseSLC = {
    overwrite_public_id: '100000-100000-100000-10000',
    payments: [
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 127500,
            bill_date: '2022-10-01',
            processing_fee: 2500,
            processing_fee_percent: 2,
            base_amount: 125000
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 127500,
            bill_date: '2022-10-15',
            processing_fee: 2500,
            processing_fee_percent: 2,
            base_amount: 125000
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 127500,
            bill_date: '2022-10-27',
            processing_fee: 2500,
            processing_fee_percent: 2,
            base_amount: 125000
        },
    ],
    cla: { version: '2022-06-28' },
    tila: { version: '2022-06-28' },
    processing_fee: {
        debit_card_processing_fee_bps: 75
    }
};
exports.overwriteCreateResponseZeroBalance = {
    overwrite_public_id: '100000-100000-100000-10000',
    payments: [],
    cla: { version: '2022-06-28' },
    tila: { version: '2022-06-28' },
    processing_fee: {
        debit_card_processing_fee_bps: 75
    }
};
exports.getRentAmountUpdateSurveyResponse = {
    choices: [
        {
            id: 1,
            response_choice: domain_1.ResponseChoice.INCORRECT_ESTIMATE,
            response_text: 'My estimate was wrong, this is my typical rent amount'
        },
        {
            id: 2,
            response_choice: domain_1.ResponseChoice.ADDITIONAL_CHARGES,
            response_text: 'There are additional charges, but this is a one-time event'
        },
        {
            id: 3,
            response_choice: domain_1.ResponseChoice.ROOMMATE_PORTION,
            response_text: 'I have a roommate who still needs to pay their portion'
        },
        {
            id: 4,
            response_choice: domain_1.ResponseChoice.BEHIND_ON_RENT,
            response_text: 'I’m behind on my rent, so there’s a balance that got carried forward'
        },
        {
            id: 5,
            response_choice: domain_1.ResponseChoice.PERMANENT_INCREASE,
            response_text: 'My rent has permanently increased'
        },
    ]
};
// DDA
exports.useDdaResponse = {
    dda_account_number: '1011231451678',
    dda_routing_number: '000000090'
};
exports.useGetDdaDecisionsResponse = {
    dda_decisions: [
        {
            from_parent_identity_id: 112323,
            bill_transaction_id: '1000000023',
            dda_transaction_id: 1020000023,
            bill_payment_initializer: orchestration_1.billPaymentInitializerEnum.SELFPAY,
            amount: 1111,
            decision: orchestration_1.decisionEnum.APPROVED,
            decision_maker: 'Flex',
            dt_due: '',
            financial_partner_type_id: 11123
        },
    ],
    block_switch_selfpay: false
};
exports.useGetDdaDecisionsIneligibleResponse = {
    dda_decisions: [
        {
            from_parent_identity_id: 112321,
            bill_transaction_id: '1000000023',
            dda_transaction_id: 1020000023,
            bill_payment_initializer: orchestration_1.billPaymentInitializerEnum.SELFPAY,
            amount: 1111,
            decision: orchestration_1.decisionEnum.APPROVED,
            decision_maker: 'Flex',
            dt_due: '',
            financial_partner_type_id: 11123
        },
        {
            from_parent_identity_id: 112322,
            bill_transaction_id: '1000000023',
            dda_transaction_id: 1020000023,
            bill_payment_initializer: orchestration_1.billPaymentInitializerEnum.SELFPAY,
            amount: 1111,
            decision: orchestration_1.decisionEnum.APPROVED,
            decision_maker: 'Flex',
            dt_due: '',
            financial_partner_type_id: 11123
        },
        {
            from_parent_identity_id: 112323,
            bill_transaction_id: '1000000023',
            dda_transaction_id: 1020000023,
            bill_payment_initializer: orchestration_1.billPaymentInitializerEnum.SELFPAY,
            amount: 1111,
            decision: orchestration_1.decisionEnum.APPROVED,
            decision_maker: 'Flex',
            dt_due: '',
            financial_partner_type_id: 11123
        },
        {
            from_parent_identity_id: 112324,
            bill_transaction_id: '1000000023',
            dda_transaction_id: 1020000023,
            bill_payment_initializer: orchestration_1.billPaymentInitializerEnum.SELFPAY,
            amount: 1111,
            decision: orchestration_1.decisionEnum.APPROVED,
            decision_maker: 'Flex',
            dt_due: '',
            financial_partner_type_id: 11123
        },
    ],
    block_switch_selfpay: true
};
// VC
exports.useVirtualCardResponse = {
    vc_name: 'Hector Bastida'
};
exports.unpauseBillerAccountResponseFailed = {
    message: 'you paused within the last 30 days.'
};
// Offers
exports.orchestrationInitiateOfferResponse = {
    risk_offer: risk_1.initiatedOffer,
    pricing_offer: {
        debit_card_fee_percent: 0.0075,
        debit_card_fee_bips: 75,
        debit_card_fee_amount: 975,
        credit_card_fee_percent: 0.03,
        credit_card_fee_bips: 300,
        credit_card_fee_amount: 3900,
        membership_fee_amount: 1499,
        experimentation_bucket: 1,
        property_passthrough_fee_amount: 300
    }
};
exports.orchestrationEvaluateOfferResponse = {
    risk_offer: risk_1.pendingOffer,
    pricing_offer: {
        debit_card_fee_percent: 0.0075,
        debit_card_fee_bips: 75,
        debit_card_fee_amount: 975,
        credit_card_fee_percent: 0.03,
        credit_card_fee_bips: 300,
        credit_card_fee_amount: 3900,
        membership_fee_amount: 1499,
        experimentation_bucket: 1,
        property_passthrough_fee_amount: 300
    }
};
exports.orchestrationEvaluateSLCOfferResponse = {
    risk_offer: risk_1.pendingOfferSLC,
    pricing_offer: {
        finance_charge_percent: 0.02,
        debit_card_fee_percent: 0.02,
        debit_card_fee_bips: 200,
        debit_card_fee_amount: 0,
        credit_card_fee_percent: 0.03,
        credit_card_fee_bips: 300,
        credit_card_fee_amount: 3900,
        membership_fee_amount: 0,
        experimentation_bucket: 1,
        property_passthrough_fee_amount: 300
    }
};
exports.orchestrationEvaluateCreditBuilderOfferResponse = {
    risk_offer: risk_1.pendingOfferCreditBuilder,
    pricing_offer: {
        debit_card_fee_percent: 0.0075,
        debit_card_fee_bips: 75,
        debit_card_fee_amount: 975,
        credit_card_fee_percent: 0.03,
        credit_card_fee_bips: 300,
        credit_card_fee_amount: 3900,
        membership_fee_amount: 1499,
        experimentation_bucket: 1,
        property_passthrough_fee_amount: 300
    }
};
exports.orchestrationEvaluateIncomeVerificationOfferResponse = {
    risk_offer: risk_1.pendingOfferIncomeVerification,
    pricing_offer: {
        debit_card_fee_percent: 0.0075,
        debit_card_fee_bips: 75,
        debit_card_fee_amount: 975,
        credit_card_fee_percent: 0.03,
        credit_card_fee_bips: 300,
        credit_card_fee_amount: 3900,
        membership_fee_amount: 1499,
        experimentation_bucket: 1,
        property_passthrough_fee_amount: 300
    }
};
exports.orchestrationEvaluateDocumentVerificationOfferResponse = {
    risk_offer: risk_1.pendingOfferDocumentVerification,
    pricing_offer: {
        debit_card_fee_percent: 0.0075,
        debit_card_fee_bips: 75,
        debit_card_fee_amount: 975,
        credit_card_fee_percent: 0.03,
        credit_card_fee_bips: 300,
        credit_card_fee_amount: 3900,
        membership_fee_amount: 1499,
        experimentation_bucket: 1,
        property_passthrough_fee_amount: 300
    }
};
exports.orchestrationEvaluateOfferDuplicateSSNResponse = {
    message: 'This information is associated with an existing Flex account. Please continue to use that account. If you have never created an account with Flex please contact customer support immediately',
    reason: orchestration_1.BusinessLogicExceptionEnum.ELIGIBILITY_CHECK_FAILED
};
exports.getPricingOfferResponse = {
    debit_card_fee_percent: 0.0075,
    debit_card_fee_bips: 75,
    debit_card_fee_amount: 975,
    credit_card_fee_percent: 0.03,
    credit_card_fee_bips: 300,
    credit_card_fee_amount: 3900,
    membership_fee_amount: 1499,
    experimentation_bucket: 1,
    property_passthrough_fee_amount: 300
};
exports.getPricingOfferSLCResponse = {
    debit_card_fee_percent: 0.0075,
    debit_card_fee_bips: 75,
    debit_card_fee_amount: 975,
    credit_card_fee_percent: 0.03,
    credit_card_fee_bips: 300,
    credit_card_fee_amount: 3900,
    membership_fee_amount: 0,
    experimentation_bucket: 1,
    property_passthrough_fee_amount: 300
};
exports.getPricingOfferFSLCResponse = {
    debit_card_fee_percent: 0.0075,
    debit_card_fee_bips: 75,
    debit_card_fee_amount: 975,
    credit_card_fee_percent: 0.03,
    credit_card_fee_bips: 300,
    credit_card_fee_amount: 3900,
    membership_fee_amount: 0,
    experimentation_bucket: 1,
    property_passthrough_fee_amount: 300
};
exports.getPricingOfferResponseMLA = {
    debit_card_fee_percent: 0.0075,
    debit_card_fee_bips: 75,
    debit_card_fee_amount: 975,
    credit_card_fee_percent: 0.03,
    credit_card_fee_bips: 300,
    credit_card_fee_amount: 3900,
    membership_fee_amount: 0,
    membership_fee_reason: 'Free membership for active military',
    experimentation_bucket: 1
};
exports.orchestrationEvaluateOfferResponseMLA = {
    risk_offer: risk_1.pendingOffer,
    pricing_offer: exports.getPricingOfferResponseMLA
};
exports.evaluateOutstandingBalanceDQResponse = {
    can_pay_now: true,
    bill_transaction_id: '1000000023',
    total_amount: 101507,
    base_amount: 100752
};
exports.evaluateOutstandingBalanceNotDQResponse = {
    can_pay_now: false,
    bill_transaction_id: '',
    total_amount: 0,
    base_amount: 0
};
exports.paymentFailureExceptionResponse = {
    reason: orchestration_1.BusinessLogicExceptionEnum.PAYMENT_FAILURE,
    message: ''
};
exports.propertiesSearchResponse = {
    property_search_results: [
        {
            integration_type: domain_1.IntegrationType.REALPAGE,
            biller_property_id: '88',
            pmc_id: '4593629',
            property_id: '4593630',
            property_name: 'Flexible Finance - Meadow Bay',
            address_line_1: '123 Main St',
            address_line_2: undefined,
            city: 'Richardson',
            state: 'TX',
            postal_code: '75005'
        },
        {
            integration_type: domain_1.IntegrationType.YARDI,
            pmc_id: 'flex-dev',
            biller_property_id: '105',
            property_id: 'flex01',
            property_name: 'Flex Test Property 1',
            address_line_1: '100 West Channel Road',
            address_line_2: undefined,
            city: 'Santa Monica',
            state: 'CA',
            postal_code: '90402'
        },
        {
            integration_type: domain_1.IntegrationType.PORTAL,
            pmc_id: undefined,
            biller_property_id: '7',
            property_id: 'portalproperty1',
            property_name: 'Portal Property Mocked',
            address_line_1: '123 Main St',
            address_line_2: undefined,
            city: 'Chicago',
            state: 'IL',
            postal_code: '60610'
        },
        {
            integration_type: domain_1.IntegrationType.PORTAL,
            pmc_id: undefined,
            biller_property_id: '29',
            property_id: 'Public-id-123',
            property_name: 'Fake Place',
            address_line_1: '111 S Michigan',
            address_line_2: undefined,
            city: 'Chicago',
            state: 'IL',
            postal_code: '60603'
        },
    ]
};
exports.inAppDownpaymentFailed = {
    reason: orchestration_1.BusinessLogicExceptionEnum.PAYMENT_FAILURE,
    message: 'Insufficient funds'
};
exports.getOnboardingStatusResponse = {
    steps_variant: orchestration_1.OnboardingStepsVariant.CONTROL,
    steps: [
        {
            step: orchestration_1.OnboardingStep.ACCOUNT_CREATION,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 0
        },
        {
            step: orchestration_1.OnboardingStep.PROPERTY_SELECTION,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 1
        },
        {
            step: orchestration_1.OnboardingStep.RENT_ESTIMATION,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 2
        },
        {
            step: orchestration_1.OnboardingStep.CREDIT_ELIGIBILITY_CHECK,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 3
        },
        {
            step: orchestration_1.OnboardingStep.REPAYMENT_SCHEDULING,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 4
        },
        {
            step: orchestration_1.OnboardingStep.PAYMENT_METHOD_SETUP,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 5
        },
        {
            step: orchestration_1.OnboardingStep.OFFER_ACCEPT,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 5
        },
    ]
};
exports.getResumeOnboardingStatusResponse = {
    steps_variant: orchestration_1.OnboardingStepsVariant.CONTROL,
    steps: [
        {
            step: orchestration_1.OnboardingStep.ACCOUNT_CREATION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 0
        },
        {
            step: orchestration_1.OnboardingStep.PROPERTY_SELECTION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 1
        },
        {
            step: orchestration_1.OnboardingStep.RENT_ESTIMATION,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 2
        },
        {
            step: orchestration_1.OnboardingStep.CREDIT_ELIGIBILITY_CHECK,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 3
        },
        {
            step: orchestration_1.OnboardingStep.REPAYMENT_SCHEDULING,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 4
        },
        {
            step: orchestration_1.OnboardingStep.PAYMENT_METHOD_SETUP,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 5
        },
        {
            step: orchestration_1.OnboardingStep.OFFER_ACCEPT,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 5
        },
    ]
};
exports.getCreditBuilderResumeOnboardingStatusResponse = {
    steps_variant: orchestration_1.OnboardingStepsVariant.CREDIT_BUILDER,
    steps: [
        {
            step: orchestration_1.OnboardingStep.ACCOUNT_CREATION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 0
        },
        {
            step: orchestration_1.OnboardingStep.PROPERTY_SELECTION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 1
        },
        {
            step: orchestration_1.OnboardingStep.RENT_ESTIMATION,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 2
        },
        {
            step: orchestration_1.OnboardingStep.CREDIT_ELIGIBILITY_CHECK,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 3
        },
        {
            step: orchestration_1.OnboardingStep.REPAYMENT_SCHEDULING,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 4
        },
        {
            step: orchestration_1.OnboardingStep.PAYMENT_METHOD_SETUP,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 5
        },
        {
            step: orchestration_1.OnboardingStep.OFFER_ACCEPT,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 5
        },
    ]
};
exports.getResumeOnboardingEpisodicStatusResponse = {
    steps_variant: orchestration_1.OnboardingStepsVariant.TREATMENT,
    steps: [
        {
            step: orchestration_1.OnboardingStep.ACCOUNT_CREATION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 0
        },
        {
            step: orchestration_1.OnboardingStep.PROPERTY_SELECTION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 1
        },
        {
            step: orchestration_1.OnboardingStep.RENT_ESTIMATION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 2
        },
        {
            step: orchestration_1.OnboardingStep.CREDIT_ELIGIBILITY_CHECK,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 3
        },
        {
            step: orchestration_1.OnboardingStep.CONFIRM_APPROVAL,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 4
        },
        {
            step: orchestration_1.OnboardingStep.SETUP_AUTOPILOT,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 5
        },
        {
            step: orchestration_1.OnboardingStep.REPAYMENT_SCHEDULING,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 6
        },
        {
            step: orchestration_1.OnboardingStep.PAYMENT_METHOD_SETUP,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 7
        },
        {
            step: orchestration_1.OnboardingStep.OFFER_ACCEPT,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 8
        },
    ]
};
exports.getResumeOnboardingFAStatusResponse = {
    steps_variant: orchestration_1.OnboardingStepsVariant.CONTROL,
    steps: [
        {
            step: orchestration_1.OnboardingStep.ACCOUNT_CREATION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 0
        },
        {
            step: orchestration_1.OnboardingStep.PROPERTY_SELECTION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 1
        },
        {
            step: orchestration_1.OnboardingStep.RENT_ESTIMATION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 2
        },
        {
            step: orchestration_1.OnboardingStep.CREDIT_ELIGIBILITY_CHECK,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 3
        },
        {
            step: orchestration_1.OnboardingStep.CONFIRM_APPROVAL,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 4
        },
        {
            step: orchestration_1.OnboardingStep.SETUP_AUTOPILOT,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 5
        },
        {
            step: orchestration_1.OnboardingStep.REPAYMENT_SCHEDULING,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 6
        },
        {
            step: orchestration_1.OnboardingStep.PAYMENT_METHOD_SETUP,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 7
        },
        {
            step: orchestration_1.OnboardingStep.OFFER_ACCEPT,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 8
        },
    ]
};
exports.getResumeOnboardingIVResponse = {
    steps_variant: orchestration_1.OnboardingStepsVariant.CONTROL,
    steps: [
        {
            step: orchestration_1.OnboardingStep.ACCOUNT_CREATION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 0
        },
        {
            step: orchestration_1.OnboardingStep.PROPERTY_SELECTION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 1
        },
        {
            step: orchestration_1.OnboardingStep.RENT_ESTIMATION,
            status: orchestration_1.OnboardingStepStatus.COMPLETE,
            order: 2
        },
        {
            step: orchestration_1.OnboardingStep.CREDIT_ELIGIBILITY_CHECK,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 3
        },
        {
            step: orchestration_1.OnboardingStep.REPAYMENT_SCHEDULING,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 4
        },
        {
            step: orchestration_1.OnboardingStep.PAYMENT_METHOD_SETUP,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 5
        },
        {
            step: orchestration_1.OnboardingStep.OFFER_ACCEPT,
            status: orchestration_1.OnboardingStepStatus.NOT_STARTED,
            order: 5
        },
    ]
};
exports.getBillerPropertyDetailsResponse = {
    property_id: 100,
    name: 'LF Ansley 1 LLC',
    identity_biller_id: 566,
    location: {
        address_line_1: '1200 Robley Drive',
        address_line_2: null,
        city: 'Lafayette',
        state: 'LA',
        postal_code: '70503',
        latitude: 30.1662842,
        longitude: -92.0746015
    },
    integration_type: domain_1.IntegrationType.YARDI,
    billing_integration_type: 'YARDI',
    public_id: 'recAzX6eD7ByDduQ3',
    status: domain_1.BillerPropertyStatus.ACTIVE,
    pmc_id: 202,
    pmc_name: 'Westminster Management',
    external_pmc_id: 'westminster',
    external_property_id: 'ansley',
    portal_id: null,
    created_at: '2022-09-27T13:46:47',
    updated_at: '2023-01-26T23:56:47',
    current_tier: null,
    qualified_tier: null
};
exports.getBillerPropertyDetailsFlexAnywhereResponse = {
    external_pmc_id: null,
    portal_id: 0,
    property_id: 76,
    name: 'George Urban Plaza',
    identity_biller_id: 40233,
    location: {
        address_line_1: '7416-420 Jersey Street 811263',
        address_line_2: '',
        city: 'Buffalo',
        state: 'NY',
        postal_code: '14213',
        latitude: 42.9039911,
        longitude: -78.8828403
    },
    integration_type: domain_1.IntegrationType.FLEX_ANYWHERE,
    billing_integration_type: '',
    public_id: 'iv2500fa9564e204d6e96ad9199524feca3',
    status: domain_1.BillerPropertyStatus.ACTIVE,
    pmc_id: 10,
    pmc_name: 'Flex Anywhere Test PMC In Network',
    external_property_id: 'fa-no-external-access',
    created_at: '2024-01-31T22:01:44',
    updated_at: '2024-01-31T22:02:25',
    current_tier: null,
    qualified_tier: null
};
exports.getBillerPropertyUnitResponse = {
    label: '0124',
    unit: '0124',
    address_line_1: '2770 Summer Street #124',
    address_line_2: null,
    city: 'Houston',
    state: 'TX',
    postal_code: '77007'
};
exports.getBillerResidentPrefillResponse = {
    property_id: 100,
    property_name: 'LF Ansley 1 LLC',
    integration_type: domain_1.IntegrationType.YARDI,
    unit: '0124'
};
exports.oonSelfPayStartResponse = {
    oon_self_pay_start_public_id: '00000-aaaaa-22222-ssss-33333',
    payments: [
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.FIRST_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 15000,
            bill_date: '2024-02-01',
            next_auth_attempt: '2024-02-05'
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 1499,
            bill_date: '2024-02-15'
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            user_payment_public_id: '10001-10001-10001-10000',
            amount: 15000,
            bill_date: '2024-02-15'
        },
    ]
};
exports.getFeatureStatusResponse = {
    feature_statuses: [
        {
            feature: orchestration_1.Feature.MODIFY_CREDIT_LINE_UTILIZATION,
            status: orchestration_1.Status.ACTIVE
        },
    ]
};
exports.getFeatureStatusFlexLiteResponse = {
    feature_statuses: [
        {
            feature: orchestration_1.Feature.MODIFY_CREDIT_LINE_UTILIZATION,
            status: orchestration_1.Status.INACTIVE
        },
    ]
};
exports.oonSelfPayVirtualCardResponse = {
    created: true,
    status: orchestration_1.CardStatus.READY,
    balance: {
        limit: 175000,
        used: 0
    },
    virtual_card: exports.useVirtualCardResponse
};
exports.getLocationSuggestResponse = {
    skip_confirmation: false,
    address: {
        address_line_1: 'test',
        address_line_2: 'test2',
        city: 'testCity',
        state: 'testState',
        zip: 'testZip'
    }
};
exports.pausedAutopayResponse = {
    autopay_history_record_public_id: 'asdfg-12345-hjklp-09876-a1s2d'
};
exports.cancelAccountSuccessResponse = {
    autopay_history_record_public_id: 'asdfg-12345-hjklp-09876-a1s2d'
};
exports.cancelAccountFailureResponse = {
    reason: orchestration_1.BusinessLogicExceptionEnum.OUTSTANDING_WALLET_BALANCE
};
exports.getBillerPropertyUnitsResponse = {
    units: [
        {
            label: '01101',
            unit: '01101',
            address_line_1: '1200 Robley Dr',
            address_line_2: 'Unit 1101',
            city: 'Lafayette',
            state: 'LA',
            postal_code: '70503'
        },
        {
            label: '01102',
            unit: '01102',
            address_line_1: '1200 Robley Dr',
            address_line_2: 'Unit 1102',
            city: 'Lafayette',
            state: 'LA',
            postal_code: '70503'
        },
    ]
};
exports.getBillerPropertyPortalDetailsResponse = {
    portal_name: 'appfolio',
    display_name: 'Appfolio',
    login_url: 'https://pacificcrest.appfolio.com/connect/users/sign_in?a=cw&utm_source=apmsites_v3&utm_campaign=tportal_login',
    forgot_password_url: 'https://passport.appf.io/sign_in/forgot_password?idp_type=tportal&vhostless=true&waldo=true',
    register_url: '',
    logo_url: 'https://assets.getflex.com/appfolio-White.png',
    color_logo_url: 'https://assets.getflex.com/appfolio.png',
    background_color: '#0090bf',
    foreground_color: '#ffffff',
    username_field_name: 'Email',
    password_field_name: 'Password'
};
exports.walletBalanceResponse = {
    available: 200000,
    current: 300000
};
exports.walletBalanceResponseAddFunds = {
    available: 5000,
    current: 15000
};
exports.setupCardV2ResponseExisting = {
    stripe_client_secret: '1E2D34D6F333FG34',
    current_card_match: true
};
exports.setupCardV2ResponseNew = {
    stripe_client_secret: '1E2D34D6F333FG34',
    current_card_match: false
};
exports.setupCardV2ResponseCardLinkageFailure = {
    ok: true,
    data: null,
    error: {
        code: orchestration_1.WalletErrorCodes.W_CARD_LINKAGE_THRESHOLD,
        message: 'This card is linked to another account.'
    }
};
exports.setupCardV2ResponseGenericFailure = {
    ok: true,
    data: null,
    error: {
        code: orchestration_1.WalletErrorCodes.W_UNCAUGHT_EXCEPTION,
        message: 'Unexpected status'
    }
};
exports.defaultCard = {
    stripe_customer_id: '12345-asdfg-23456-sdfgh-1z2x3',
    brand: 'Visa',
    card_mask: '5556',
    is_active: true,
    stripe_payment_method_id: 'mklpo-09876-njiuh-98765-vgytf',
    card_type: 'debit',
    fingerprint: 'AW34FGTY78HGHF',
    issuer: 'VISA',
    is_stripe_connect_setup: true
};
exports.newCard = {
    stripe_customer_id: '12345-asdfg-23456-sdfgh-1z2x3',
    brand: 'Visa',
    card_mask: '5556',
    is_active: false,
    stripe_payment_method_id: 'mklpo-09876-njiuh-98765-vgytf',
    card_type: 'debit',
    fingerprint: 'AW34FGTY78HGHF',
    issuer: 'VISA',
    is_stripe_connect_setup: false
};
exports.creditCard = {
    stripe_customer_id: '12345-asdfg-23456-sdfgh-1z2x3',
    brand: 'Visa',
    card_mask: '4242',
    is_active: false,
    stripe_payment_method_id: 'mklpo-09876-njiuh-98765-vgytf',
    card_type: 'credit',
    fingerprint: 'AW34FGTY78HGHF',
    issuer: 'VISA',
    is_stripe_connect_setup: false
};
exports.getCardsV2New = {
    "default": exports.newCard
};
exports.getCardsV2Existing = {
    "default": exports.defaultCard
};
exports.getCardsV2Credit = {
    "default": exports.creditCard
};
exports.addFundsMaxDepositsFailure = {
    data: null,
    error: {
        code: orchestration_1.WalletErrorCodes.W_ADD_FUNDS_MAX_ATTEMPTS_EXCEEDED,
        message: 'No more deposits this month.'
    }
};
exports.addFundsInvalidAmountFailure = {
    data: null,
    error: {
        code: orchestration_1.WalletErrorCodes.W_ADD_FUNDS_INVALID_AMOUNT,
        message: 'Invalid amount.'
    }
};
exports.withdrawFundsFailure24Hours = {
    data: null,
    error: {
        code: orchestration_1.WalletErrorCodes.W_WITHDRAW_PAYMENT_METHOD_ADDED_WITHIN_24_HOURS,
        message: 'You must wait 24 hours to withdraw to a new card.'
    }
};
exports.withdrawFundsInvalidAmountFailure = {
    data: null,
    error: {
        code: orchestration_1.WalletErrorCodes.W_WITHDRAW_FUNDS_INVALID_AMOUNT,
        message: 'Invalid amount.'
    }
};
exports.addFundsMaxDepositsRateLimit = {
    data: null,
    error: {
        code: 'G20002',
        message: 'We are experiencing a high volume of requests at the moment. Please wait a few minutes and try again.'
    }
};
exports.withdrawFundsRateLimit = {
    data: null,
    error: {
        code: 'G20002',
        message: 'Too many attempts.'
    }
};
exports.withdrawFundsMaxWithdrawalsReached = {
    data: null,
    error: {
        code: orchestration_1.WalletErrorCodes.W_WITHDRAW_FUNDS_MAX_COUNTED_EXCEEDED,
        message: 'No more withdrawals this month.'
    }
};
exports.getRentReportingOptInStatus = {
    opt_in_status: true
};
exports.flexAnywhereInsufficientFunds = {
    reason: orchestration_1.BusinessLogicExceptionEnum.INSUFFICIENT_FUNDS
};
exports.flexAnywhereGenericPaymentFailure = {
    reason: orchestration_1.BusinessLogicExceptionEnum.PAYMENT_GENERIC_DECLINE
};
exports.flexAnywhereDefaultPaymentFailure = {
    reason: orchestration_1.BusinessLogicExceptionEnum.PAYMENT_DEFAULT_FAILURE
};
exports.flexAnywhereUpdateCard = {
    reason: orchestration_1.BusinessLogicExceptionEnum.PAYMENT_UPDATE_CARD
};
exports.oonSelfPayStartSlcSPEnabled = {
    oon_self_pay_start_public_id: '861154d6-f351-4706-9667-af99f8fc8492',
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
            amount: 1499,
            bill_date: '2024-03-15'
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.FIRST_PAYMENT,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            bill_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
            is_additional_security_deposit: false,
            is_security_deposit: true
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            bill_date: '2024-03-15'
        },
    ]
};
exports.oonSelfPayStartSlcSPDisabled = {
    oon_self_pay_start_public_id: '861154d6-f351-4706-9667-af99f8fc8492',
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
            amount: 1499,
            bill_date: '2024-03-15'
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            bill_date: '2024-03-15'
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.FIRST_PAYMENT,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            bill_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
            is_additional_security_deposit: false,
            is_security_deposit: true
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            bill_date: '2024-04-27'
        },
    ]
};
exports.oonSelfPayStartSlcSPDisabledMonthTwo = {
    oon_self_pay_start_public_id: '861154d6-f351-4706-9667-af99f8fc8492',
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
            amount: 1499,
            bill_date: '2024-03-15'
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.FIRST_PAYMENT,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            bill_date: '2024-03-15',
            is_security_deposit: false,
            is_additional_security_deposit: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            bill_date: '2024-04-27'
        },
    ]
};
exports.oonSelfPayStartSlcSPDisabledMonthTwoAdditionalDeposit = {
    oon_self_pay_start_public_id: '861154d6-f351-4706-9667-af99f8fc8492',
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
            amount: 1499,
            bill_date: '2024-03-15'
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            amount: 51500,
            base_amount: 50000,
            processing_fee: 1500,
            processing_fee_percent: 1.0,
            bill_date: '2024-03-15'
        },
        // This is the payment we target for the new flags
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.FIRST_PAYMENT,
            amount: 1200,
            base_amount: 1200,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            bill_date: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
            is_additional_security_deposit: true,
            is_security_deposit: true
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            amount: 100000,
            base_amount: 100000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            bill_date: '2024-04-27'
        },
    ]
};
exports.oonSelfPayStartSLCDisabledMonthTwoDepositPaid = {
    oon_self_pay_start_public_id: '861154d6-f351-4706-9667-af99f8fc8492',
    payments: [
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.PAID,
            amount: 60000,
            base_amount: 60000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 0,
            bill_date: '2024-02-27',
            payment_category: domain_1.PaymentCategory.FIRST_PAYMENT,
            can_pre_fund: false,
            is_security_deposit: true
        },
        {
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            amount: 1499,
            outstanding_balance: 1499,
            bill_date: '2024-03-15',
            payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
            user_payment_public_id: '10001-10001-10001-10000',
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            amount: 51111,
            base_amount: 50000,
            processing_fee: 1111,
            processing_fee_percent: 1.0,
            outstanding_balance: 51111,
            bill_date: '2024-03-24',
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
        {
            user_payment_public_id: '10001-10001-10001-10000',
            payment_status: domain_1.PaymentStatus.SCHEDULED,
            amount: 60000,
            base_amount: 60000,
            processing_fee: 0,
            processing_fee_percent: 0.0,
            outstanding_balance: 60000,
            bill_date: '2024-03-27',
            payment_category: domain_1.PaymentCategory.SECOND_PAYMENT,
            can_pre_fund: false
        },
    ]
};
